/* eslint-disable no-unused-vars */
import index from './index.js';
import register from './register.js';

// Polyfills
import raf from './lib/raf';
import placeholder from './lib/placeholder';
import './lib/polyfills/assign';
import './lib/polyfills/nodelist-foreach';
import './lib/polyfills/closest';

// App
import bring_me_starry_form   from './lib/bring-me-starry-form';
import bring_me_starry_letter   from './lib/bring-me-starry-letter';
import email_subscribe_footer from './lib/email-subscribe-footer';
import email_subscribe_modal from './lib/email-subscribe-modal';
import acumen from './lib/acumen/index';
import acumen_bootstrap from './lib/acumen/bootstrap';
import video from './lib/video.js';
import gtm from './lib/gtm.js';
import reviews_carousel from './lib/reviews-carousel.js';
import amazon_reviews_carousel from './lib/amazon-reviews-carousel.js';
import press_quotes_carousel from './lib/press-quotes-carousel.js';
import main_nav from './lib/main-nav.js';
import hero_carousel from './lib/hero-carousel.js';
import sticky_station from './lib/sticky-station.js';
import specs from './lib/specs.js';
import buy_now_test from './lib/buy-now-test.js';
import clicks from './lib/clicks.js';
import orbs_animation from './lib/orbs-animation.js';
import './lib/mdu-refer.js';
import tech_specs_toggle from './lib/tech-specs-toggle.js';
import zendesk from './lib/zendesk-chat.js';
import check_availability from './lib/check-availability.js';
import internet_speed_carousel from './lib/internet-speed-carousel.js';
import smooth_scroll_links from './lib/smooth-scroll-links.js';
import home_station_carousel from './lib/home-station-carousel.js';
import star_animation from './lib/star-animation.js';
import accordions from './lib/accordions.js';
import dropdowns from './lib/dropdowns.js';
import ces_network_carousel from './lib/ces-network-carousel.js';
import jobs_dropdown from './lib/jobs-dropdown';
import manager_reviews_carousel from './lib/manager-reviews-carousel.js';
import building_types_carousel from './lib/building-types-carousel.js';
import fix_the_internet from './lib/fix-the-internet.js';
import ticker_tape from './lib/ticker-tape.js';
import space_cowboy from './lib/space-cowboy.js';
import about_page from './lib/about-page.js';
import properties_page from './lib/properties-page.js';
import technology_page from './lib/technology-page.js';
import inView from './lib/util/in-view';
import catPong from './lib/cat-pong.js';
import tooltip from './lib/tooltip.js';
import siteFooter from './lib/site-footer.js';
import serviceableForm from './lib/serviceable-form';
import managementReferralForm from './lib/management-referral-form';
import urgencyBanner from './lib/urgency-banner';
import customer_reviews_carousel from './lib/customer-reviews-carousel';
import privacy_toc from './lib/privacy-toc';
import pi_request_form from './lib/pi-request-form';
import check_serviceability from './lib/check-serviceability';
import check_b2b_serviceability from './lib/check-b2b-servicablilty.js';
import check_avail_service_page from './lib/check-avail-service-page';
import serviceable_form_freeinternet from './lib/serviceable-form-freeinternet';
import neighborhood_list_dropdown from './lib/neighborhood-list-dropdown';
import petition_landing_form from './lib/petition-landing-form';
import check_avail_petition from './lib/check-avail-petition';
import social_share_petition from './lib/social-share-petition';
import calendly_meeting from './lib/calendly-meeting';
import press_reviews_carousel from './lib/press-reviews-carousel';
import trustpilot_reviews from './lib/trustpilot-reviews';
import sms_qr_link_form from './lib/sms-qr-link-form';
import progress_carousel from './lib/progress-carousel';
import home_reviews_carousel from './lib/home-reviews-carousel';
import connect_press_quotes_carousel from './lib/connect-press-quotes-carousel';
import connect_chat from './lib/connect-chat.js';
import acp_request_form from './lib/acp-request-form';
import investor_emails  from './lib/investor-updates-subscribe';
import columbus_plan_carousel from './lib/columbus-plan-carousel';
import columbus_review_carousel from './lib/columbus-customer-reviews-carousel';
import vegas_plan_carousel from './lib/vegas-plan-carousel';
import smart_network_carousel from './lib/smart-network-carousel';
import app_integration_carousel from './lib/app-integration-carousel';
import internet_plan_carousel from './lib/internet_plan_carousel';
import aura_features_carousel from './lib/aura-features-carousel';
import aura_awards_carousel from './lib/aura-awards-carousel';
import card_carousel from './lib/card-carousel';
import check_smb_availability from './lib/check-smb-availability';
import redeem_tango from './lib/redeem-tango.js';

document.addEventListener( 'DOMContentLoaded', function() {

  // bootstrap global scroll animations
  inView({
    selector: '[data-scroll-animate]',
    onEnter: el => el.classList.add('in-view'),
    offset: 250,
    once: true
  });

  // track keyboard/pointer input for :focus styles
  document.addEventListener( 'keydown', e => {
    const { key } = e;
    if ( key === 'Shift' || key === 'Tab' ) {
      document.body.dataset.userinput = 'keyboard';
    }
  });

  document.addEventListener( 'mousedown', () => {
    document.body.dataset.userinput = 'pointer';
  });

  let elems = document.querySelectorAll('[data-module]');
  Array.prototype.slice.call( elems ).forEach( function( elem ) {
    let name = elem.getAttribute('data-module');
    let mod = register.registry[ name ];

    if ( typeof mod === 'function' ) {
      try {
        mod();
      } catch ( err ) {
        console.error( err );
      }
      delete register.registry[ name ];
    }
  });
});
